import {SEARCHMODE} from './store-locator.mjs';

/**
 * Address not found form handlers
 */
export function initFindCivicAddressesForm(container, {
  idPrefix= 'fcaddresses',
  onsuccess,
  onfailure
} = {}) {

  // fcaddresses stands for find civic addresses.
  const form      = container.querySelector(`.js-${idPrefix}-form`);
  const submitBtn = container.querySelector(`.js-${idPrefix}-submit`);

  form.addEventListener('submit', async event => {
    event.preventDefault();
    // Empty list before anything else.
    document.querySelector(`.js-${idPrefix}-list`).innerHTML = '';

    submitBtn.classList.replace('btn--chevron', 'btn--loading');
    try {
      const data = await Promutuel.mutuals.findCivicAddresses({
        civicnumber : document.querySelector(`#${idPrefix}__input-civic-number`).value,
        postalcode  : document.querySelector(`#${idPrefix}__input-postalcode`).value,
      });
      if (onsuccess)  {
        const list = document.createElement('ul');
        // Returning values can be mucho different.
        if (typeof data === 'object' && !Array.isArray(data)) {
          let item = createItem(data);
          list.appendChild(item);
        } else {
          for (let i of data) {
            let item = createItem(i);
            list.appendChild(item);
          }
        }
        document.querySelector(`.js-${idPrefix}-list`).appendChild(list);
      }
    }
    catch (err) {
      if (onfailure)
        console.log(err);
        const list = document.createElement('ul');
        const item = document.createElement('li');
        const message = Drupal.t('Address not found');
        item.classList.add('js-fcaddresses-not-found');
        item.textContent = message;
        list.appendChild(item);
        document.querySelector(`.js-${idPrefix}-list`).appendChild(list);
    }
    submitBtn.classList.replace('btn--loading', 'btn--chevron');
  });

  // Create address from data.
  function createItem(i) {
    let item = document.createElement('li');
    let parts = [ i.civicNumber, i.civicNumberSuffix, i.streetName,  i.municipality, i.postalCode];
    item.innerHTML = parts.join(' ');

    return item;
  }

}
